<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="关键字" class="kw">
          <el-input
            placeholder="请输入"
            v-model="searchData.keywordValue"
            class="input-with-select"
            size="small"
          >
            <el-select
              v-model="searchData.keywordName"
              slot="prepend"
              placeholder="请选择"
              size="small"
              style="width: 100px"
            >
              <el-option
                v-for="item in searchTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="资方归属">
          <select-capital-org
            style="width: 180px"
            v-model="searchData.capitalOrgCode"
          />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            style="width: 180px"
            v-model="searchData.orderNo"
            size="small"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核时间">
          <el-date-picker
            style="width: 340px"
            v-model="reviewDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="分账时间">
          <el-date-picker
            style="width: 340px"
            v-model="royaltyDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="分账类型">
          <el-select
            style="width: 150px"
            v-model="searchData.royaltyType"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in royaltyTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分账方式">
          <el-select
            style="width: 150px"
            v-model="searchData.royaltyDeliverType"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in royaltyDeliverTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" " label-width="50px">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">查询</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="head-btn">
      <div></div>
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.capital_org_zst_royalty_list_export)"
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="handleExport"
      >导出</el-button>
    </div>

    <el-table :data="list" style="width: 100%">
      <el-table-column label="用户信息" min-width="180">
        <template slot-scope="{ row }">
          <div>
            <div>姓名：{{ row.memberName }}</div>
            <div>手机号：{{ row.memberMobile }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订单信息" min-width="280">
        <template slot-scope="{ row }">
          <div>
            <div>订单单号：{{ row.orderNo }}</div>
            <div>交易组件单号：{{ row.alipayOrderId }}</div>
            <div>下单时间：{{ row.orderCreateTime }}</div>
            <div>订单状态：{{ row.orderStatusName }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="资方归属" min-width="240">
        <template slot-scope="{ row }">
          <div>
            <div>名称：{{ row.investName }}</div>
            <div>审核时间：{{ row.reviewTime }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="期数" width="60">
        <template slot-scope="{ row }">
          {{ row.billNum || '–' }}
        </template>
      </el-table-column>
      <el-table-column label="分账类型" min-width="110">
        <template slot-scope="{ row }">
          {{ getZstRoyaltyTypeText(row.royaltyType) }}
        </template>
      </el-table-column>
      <el-table-column label="分账方式" min-width="110">
        <template slot-scope="{ row }">
          {{ getZstRoyaltyDeliverTypeText(row.royaltyDeliverType) }}
        </template>
      </el-table-column>
      <el-table-column prop="royaltyTradeNo" label="分账交易号" min-width="160"></el-table-column>
      <el-table-column prop="royaltyTime" label="分账时间" min-width="150"></el-table-column>
      <el-table-column prop="royaltyPrice" label="分账金额" min-width="90"></el-table-column>
      <el-table-column prop="investPrinciplePrice" label="本金" min-width="80"></el-table-column>
      <el-table-column prop="investProfitPrice" label="服务费" min-width="80"></el-table-column>
      <el-table-column prop="investTotalPrice" label="资方应收" min-width="90"></el-table-column>
      <el-table-column prop="investRepayPrice" label="资方差额回款" min-width="110"></el-table-column>
    </el-table>
    <pagination
      :total="total"
      :page.sync="searchData.page"
      :limit.sync="searchData.pageSize"
      @pagination="getList"
    />

    <div style="height: 100px"></div>
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getZstRoyaltyListAPI, exportZstRoyaltyAPI } from "./api";
import SelectCapitalOrg from "@/views/components/select-capital-org.vue";
import {
  ZstRoyaltyTypeList,
  ZstRoyaltyDeliverTypeList,
  getZstRoyaltyTypeText,
  getZstRoyaltyDeliverTypeText,
} from "@/enum/dict/zst";

const searchTypeOptions = [
  { name: "用户姓名", value: "memberName" },
  { name: "手机号", value: "memberMobile" },
  { name: "交易组件单号", value: "alipayOrderId" },
  { name: "分账交易号", value: "royaltyTradeNo" },
];

export default {
  name: "ZstRoyaltyList",
  mixins: [authBtnMixin],
  components: { SelectCapitalOrg },

  data() {
    return {
      total: 0,
      list: [],
      searchData: {
        page: 1,
        pageSize: 10,
        keywordName: "memberName",
        keywordValue: "",
        orderNo: "",
        royaltyType: "",
        royaltyDeliverType: "",
        capitalOrgCode: "",
      },
      reviewDateRange: [],
      royaltyDateRange: [],
      searchTypeOptions,
      royaltyTypeOptions: ZstRoyaltyTypeList,
      royaltyDeliverTypeOptions: ZstRoyaltyDeliverTypeList,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    getZstRoyaltyTypeText,
    getZstRoyaltyDeliverTypeText,
    
    buildParams() {
      const params = {
        page: this.searchData.page,
        pageSize: this.searchData.pageSize,
        orderNo: this.searchData.orderNo,
        royaltyType: this.searchData.royaltyType,
        royaltyDeliverType: this.searchData.royaltyDeliverType,
        capitalOrgCode: this.searchData.capitalOrgCode,
      };
      // 关键字搜索
      if (this.searchData.keywordName && this.searchData.keywordValue) {
        params[this.searchData.keywordName] = this.searchData.keywordValue;
      }
      // 审核时间
      if (this.reviewDateRange && this.reviewDateRange.length > 0) {
        params.leftReviewDate = this.reviewDateRange[0];
        params.rightReviewDate = this.reviewDateRange[1];
      }
      // 分账时间
      if (this.royaltyDateRange && this.royaltyDateRange.length > 0) {
        params.leftRoyaltyDate = this.royaltyDateRange[0];
        params.rightRoyaltyDate = this.royaltyDateRange[1];
      }
      return params;
    },

    async getList() {
      const res = await getZstRoyaltyListAPI(this.buildParams());
      this.list = res.list || [];
      this.total = res.total || 0;
    },

    reset() {
      this.reviewDateRange = [];
      this.royaltyDateRange = [];
      this.searchData = {
        page: 1,
        pageSize: this.searchData.pageSize,
        keywordName: "memberName",
        keywordValue: "",
        orderNo: "",
        royaltyType: "",
        royaltyDeliverType: "",
        capitalOrgCode: "",
      };
      this.getList();
    },

    handleExport() {
      exportZstRoyaltyAPI(this.buildParams());
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .head-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .el-form {
    .el-form-item {
      margin-right: 25px;
      margin-bottom: 10px;
    }
  }
}

.header-search {
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        .el-input,
        .el-select {
          width: 180px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
      .kw {
        .el-select .el-input {
          width: 118px;
        }
        .el-select {
          width: 120px;
        }
        .input-with-select {
          vertical-align: middle;
          width: 320px;
        }
        .input-with-select .el-input-group__prepend {
          background-color: #fff;
        }
      }
      .store {
        width: 350px;
        .el-input__inner {
          width: 230px;
        }
      }
    }
  }

</style>
